export function firstName(name) {
  if (!name) return "";
  const parts = String(name).trim().split(/\s+/);
  return parts[0] || "";
}
